import Swal from 'sweetalert2'
import { deleteByIdDepartamentos } from '../../../Services/departamentoService'

const useDeleteDepartment = (setIsLoad) => {
    const deleteDepartamento = (departamento) => {
        Swal.fire({
            title: 'Estas seguro de eliminar?',
            text: 'Se eliminara un departamento!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                deleteByIdDepartamentos(departamento.id)
                    .then((res) => {
                        Swal.fire(
                            'Eliminado!',
                            'El departamento fue eliminado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }
    return { deleteDepartamento }
}

export default useDeleteDepartment
